<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Products</translate></template>
            <template v-slot:buttons>
                <GekkoButton 
                    :text="$gettext('Download')" 
                    icon="fa fa-download" 
                    variant="outline-primary" 
                    @click="downloadCSV" 
                    class="mr-2" />
                <GekkoButton 
                    :text="$gettext('Products')"
                    :to="{ name: 'ProductListModal' }"
                    icon="fa fa-shopping-basket"
                    class="mr-2"
                />
                <GekkoButton 
                    :text="$gettext('All reports')"
                    :to="{ name: 'Reports' }"
                    icon="fa fa-chart-column"
                />
            </template>
        </TitleBar>
        <div class="content">
            <ProductListModal :show-modal-on="['ProductListModal']" />

            <ProductTable ref="product-table" />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ProductTable from "@/components/products/ProductTable";
import ProductListModal from "@/components/products/ProductListModal";

export default {
    name: "Products",
    components: { TitleBar, GekkoButton, ProductTable, ProductListModal },
    methods: {
        downloadCSV() {
            this.$refs['product-table'].downloadCSV();
        }
    }
}
</script>